export default {
  "b2b.zdroj-detail.title-placeholder": "Zdroj",
  "b2b.zdroj-detail.message-empty": "Zdroj nebyl nenalezen"
};
